import React from "react"
import SelectMenu from "../select-menu"
import { fontOptions } from "./font-options"
export { fontOptions }
// FontSelect uses the fonts defined in font-options.js as defaults.
// Pass in a custom `options` prop to override these defaults with other fonts.
// If you edit this file, always make sure `options` comes before `{...props}`.

function FontSelect(props) {
  return <SelectMenu options={fontOptions} {...props} />
}

export default FontSelect
